export interface Payment {
    id: number;
    type: PaymentType;
}

export enum PaymentType {
    dollarsPerK = "dollars_per_k",
    flatRate = "flat_rate"
}
